// import { Box, Button, Grid, Stack, Typography } from "@mui/material";
// import React from "react";
// import { styles } from "../assets/styles";
// import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";

// const Banner = ({ bannerContent }) => {
//   return (
//     <Box
//       sx={{
//         // display: "flex",
//         position: "relative",
//         top: { xs: "25%", sm: "30%" },
//         maxWidth: "85rem",
//         mx: "auto",
//         px: { xs: 2.5, sm: 5 },
//       }}
//     >
//       <Box
//         sx={{
//           width: { xs: "85%", sm: "50%" },
//           textAlign: "left",
//           backgroundColor: "#ffffffed",
//           padding: "20px",
//           borderRadius: "4px",
//           borderTop: "4px solid rgb(7, 25, 42)",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Typography
//           variant="h3"
//           sx={{
//             fontWeight: 500,
//             fontSize: 25,
//           }}
//           gutterBottom
//         >
//           {bannerContent.heading}
//         </Typography>

//         <Typography variant="body2" sx={{ fontSize: 14, mb: 3 }} gutterBottom>
//           {bannerContent.textContent}
//         </Typography>

//         {bannerContent.buttonText && (
//           <Box
//             sx={{
//               cursor: "pointer",
//               color: "rgb(7, 25, 42)",
//               // alignSelf: "flex-end",
//               "&:hover span": {
//                 opacity: 1,
//               },
//               "&:hover svg": {
//                 opacity: 1,
//               },
//             }}
//           >
//             <Stack
//               direction="row"
//               justifyContent="flex-start"
//               alignItems="center"
//             >
//               <Typography
//                 variant="subtitle"
//                 sx={{
//                   fontSize: 13,
//                   opacity: 0.7,
//                   fontWeight: 500,
//                   color: "inherit",
//                 }}
//               >
//                 Read more
//               </Typography>{" "}
//               <ArrowRightAltRoundedIcon
//                 sx={{
//                   position: "relative",
//                   color: "inherit",
//                   fontSize: 25,
//                   top: "2px",
//                   opacity: "0.5",
//                 }}
//               />
//             </Stack>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default Banner;

import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { keyframes } from "@mui/system";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Banner = ({ bannerContent }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "600px",
        textAlign: "left",
        minHeight: { xs: "unset", sm: "65vh", md: "70vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", sm: "center" },
        gap: { xs: 1.5, sm: 2 },
        zIndex: 1,
        ml: 0,
        pl: 0,
        pt: { xs: 11.5, sm: 0 },
        pb: { xs: 2, sm: 0 },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          fontSize: { xs: "12px", sm: "14px" },
          fontWeight: 700,
          background: "linear-gradient(135deg, #5b7cfa 0%, #764ba2 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          letterSpacing: "2px",
          mb: 1,
          display: "block",
          animation: `${fadeUp} 0.6s ease-out 0.05s both`,
        }}
      >
        {bannerContent.title}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: 22, sm: 36, md: 42 },
          fontWeight: 800,
          color: "#1b1f33",
          background: "linear-gradient(135deg, #5b7cfa 0%, #764ba2 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          lineHeight: 1.2,
          textAlign: "left",
          letterSpacing: "-0.5px",
          margin: 0,
          padding: 0,
          animation: `${fadeUp} 0.6s ease-out 0.1s both`,
        }}
      >
        {bannerContent.heading}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: 16, sm: 17 },
          color: "#4c5472", 
          lineHeight: 1.8,
          textAlign: "justify",
          margin: 0,
          padding: 0,
          animation: `${fadeUp} 0.6s ease-out 0.2s both`,
        }}
        dangerouslySetInnerHTML={{ __html: bannerContent.textContent }}
      ></Typography>
      {bannerContent.buttonText && (
        <Link to={bannerContent.buttonUrl}>
          <Button
            disableRipple
            variant="contained"
            sx={{ 
              background: "linear-gradient(135deg, #5b7cfa 0%, #764ba2 100%)",
              color: "#fff",
              fontWeight: 700,
              px: 4,
              py: 1.5,
              borderRadius: "12px",
              fontSize: "16px",
              textTransform: "none",
              boxShadow: "0 8px 24px rgba(91, 124, 250, 0.3)",
              width: "fit-content",
              mt: 1,
              transition: "all 0.3s ease",
              animation: `${fadeUp} 0.6s ease-out 0.3s both`,
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 32px rgba(91, 124, 250, 0.4)",
              },
            }}
          >
            {bannerContent.buttonText}
          </Button>
        </Link>
      )}
    </Box>
  );
};

export default Banner;
